// Functions to set get or check cookies variables
exports.Set = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expstoUTCString = d.toUTCString();
  const expires = `expires=${expstoUTCString}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
exports.Get = cname => {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
exports.Check = cookiename => {
  const value = exports.Get(cookiename);
  let result = '';
  if (value !== '') {
    result = value;
  } else {
    result = '';
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/main/javascripts/lib/treffcook.js